import { Badge } from '@radix-ui/themes';
import { t } from 'i18next';
import { DeliveryType } from 'lib_ts/enums/pitches.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { Nullable } from 'lib_ts/interfaces/common/i-generics';

export const VideoDeliveryBadge = (props: {
  value: Nullable<DeliveryType>;
}) => {
  switch (props.value) {
    case DeliveryType.Stretch: {
      return (
        <Badge color={RADIX.COLOR.NEUTRAL}>{t('constants.stretch')}</Badge>
      );
    }

    case DeliveryType.Windup: {
      return <Badge color={RADIX.COLOR.NEUTRAL}>{t('constants.windup')}</Badge>;
    }

    default: {
      return null;
    }
  }
};
